import React, { useState, useEffect, useMemo } from 'react'
import { CircularProgress, Divider, IconButton, LinearProgress, Typography, useMediaQuery } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import { useSnackbar } from "../snackbar/snackbar"
import styles from './styles.module.css'
import dashboardStyles from '../dashboard/styles.module.css'
import { getCurrentPlan, postPaymentSession, getAccountPlans, postCheckoutSession } from '../../api-client/data'
import useFetch from '../../hooks/useFetch'
import Button from '../nura/button/button'
import { useDispatch, Actions } from '../../stores/dashboard.store'

const PlanCard = ({ name, price, productId, features, includeCheckout = false }) => {
    const [loading, setLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar()

    const checkoutItem = async () => {
        setLoading(true)
        try {
            const data = await postCheckoutSession({
                productId
            })
            window.location.href = data.checkout_url
        } catch {
            enqueueSnackbar("Request could not be completed at this time", { variant: "success" })
        }

        setLoading(false)
    }

    return (
        <div className={styles?.planCard}>
            <div>
                <div className={styles?.planTitleHeader}>
                    <Typography style={{ flex: 1, paddingBottom: 0 }} variant="h5" className={styles.planTitle}>{name}</Typography>
                    {
                        includeCheckout && (
                            <Button size="normal" variant="fancy" disabled={loading} onClick={checkoutItem}>{loading !== true ? <>Upgrade</> : <CircularProgress size={20} />}</Button>
                        )
                    }
                </div>

                <Divider style={{ borderColor: `var(--border-secondary)` }} />
                <div className={styles.planContent}>
                    <div className={styles.planPrice}>
                        <Typography variant="h4">${price}</Typography>
                        <Typography variant="body" className={styles.priceCurrency}>USD/Month</Typography>
                    </div>
                    <Typography variant="body" style={{ color: 'var(--text-primary)' }}></Typography>
                    <ul>
                        {
                            features.map(x => (
                                <li style={{textTransform: 'capitalize'}}>{x}</li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

const Plan = () => {
    const isMobile = useMediaQuery('(max-width: 900px)')
    const plan = useFetch(getCurrentPlan)
    const plans = useFetch(getAccountPlans)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const navigateManagePlan = async () => {
        dispatch(Actions.SetIndeterminate, true)
        try {
            const data = await postPaymentSession()
            dispatch(Actions.SetIndeterminate, false)
            window.location.href = data.portal_url
        } catch (error) {
            dispatch(Actions.SetIndeterminate, false)
            console.error("Request failed:", error)
        }
        dispatch(Actions.SetIndeterminate, false)
    }

    const activeProducts = useMemo(() => plans?.data?.filter(x => plan.data?.plan?.id === x?.id), [plan, plans])
    const inActiveProducts = useMemo(() => plans?.data?.filter(x => plan.data?.plan?.id !== x?.id), [plan, plans])

    return (
        <div className={dashboardStyles.dashboardContent}>
            <div className={dashboardStyles.dashboardHeader}>
                <div className={dashboardStyles.settingsTitle} style={{ flex: 1 }}>
                    <Typography variant="h6">Your Plan</Typography>
                </div>
                {
                    plan.data?.plan?.name !== "free" && (
                        (!isMobile &&
                            <Button className={styles.planButton} onClick={navigateManagePlan} variant="fancy" size="normal">Manage</Button>
                        )
                    )
                }
            </div>
            {
                (plan.loading === true || plans.loading === true) && (
                    <LinearProgress />
                )
            }
            {
                isMobile &&
                <div className={styles.actionsGroup} >
                    <div className={styles.innerButtonBar} style={{
                        right: '9%'
                    }}>
                        <IconButton onClick={navigateManagePlan} >
                            <EditIcon />
                        </IconButton>

                    </div>
                </div>
            }
            {
                (plan.loading === true || plans.loading === true) ? null : (
                    <div className={dashboardStyles.containerScroll}>
                        <div className={styles.planSubtitle}>
                            <Typography variant="h6" className={styles.planSubheading}>Active Plan</Typography>
                        </div>
                        {
                            ({
                                [true]: <Typography>No Active Plans</Typography>,
                                [activeProducts?.length > 0]: (
                                    <div style={{ marginBottom: 30 }} className={styles.planContainer}>
                                        <div className={styles.plans}>
                                            {
                                                activeProducts?.map(x => (
                                                    <PlanCard {...x} />
                                                ))
                                            }
                                        </div>
                                    </div>
                                )
                            }).true
                        }

                        <div className={styles.planSubtitle}>
                            <Typography variant="h6" className={styles.planSubheading}>Other Plans</Typography>
                        </div>

                        <div className={styles.planContainer}>
                            <div className={styles.plans}>
                                {
                                    inActiveProducts?.map(x => (
                                        <PlanCard
                                            {...x}
                                            loading={loading}
                                            includeCheckout={plan.data?.plan?.price <= x?.price || plan.data?.plan?.name === 'free'}
                                            setLoading={setLoading}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Plan